var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.092 233.817C142.423 231.57 147.577 231.57 151.908 233.817L256 287.82L145 347.492L34 287.82L138.092 233.817Z",
    fill: "#009A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 287.82L145 347.492V468.508L42.0923 415.119C37.1206 412.54 34 407.406 34 401.805L34 287.82Z",
    fill: "#0E8231"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 287.82L145 347.492V468.508L247.908 415.119C252.879 412.54 256 407.406 256 401.805V287.82Z",
    fill: "#2DAE54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.243 47.3376C250.887 44.5756 256.658 44.5249 261.349 47.2048L367 107.549L256 167.222L145 107.549L246.243 47.3376Z",
    fill: "#009A2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145 107.549L256 167.222V288.237L153.092 234.849C148.121 232.269 145 227.135 145 221.534L145 107.549Z",
    fill: "#0E8231"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M367 107.549L256 167.222V288.237L358.908 234.849C363.879 232.269 367 227.135 367 221.534V107.549Z",
    fill: "#2DAE54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357.243 227.608C361.887 224.846 367.658 224.796 372.349 227.475L478 287.82L367 347.492L256 287.82L357.243 227.608Z",
    fill: "#009A2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 287.82L367 347.492V468.508L264.092 415.119C259.121 412.54 256 407.406 256 401.805L256 287.82Z",
    fill: "#0E8231"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M478 287.82L367 347.492V468.508L469.908 415.119C474.879 412.54 478 407.406 478 401.805V287.82Z",
    fill: "#2DAE54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.763 190.432C395.634 191.668 396.191 192.949 396.613 194.867C395.824 198.168 394.578 199.435 391.866 201.44C388.818 201.858 387.397 201.742 384.878 200.136C392.371 205.11 395.994 218.614 396.874 224.808C396.502 221.54 396.338 218.935 398.23 216.097C400.704 214.47 402.249 213.959 405.219 213.959C407.987 215.531 409.142 216.733 410.436 219.644C408.739 214.099 403.358 201.045 394.763 190.432Z",
    fill: "#003F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.029 260.461L281.701 262.365C283.036 264.368 287.265 270.989 289.212 274.049L290.258 275.245C292.56 278.77 295.074 281.692 298.184 284.533C314.184 298.374 331.608 303.648 352.64 302.425C369.641 300.912 383.966 292.122 395.048 279.578C396.635 277.711 398.059 276.059 400.063 274.648C402.103 271.249 406.492 263.867 407.723 261.53C411.744 247.614 413.809 233.982 410.436 219.644C409.142 216.733 407.987 215.531 405.219 213.959C402.249 213.959 400.704 214.47 398.23 216.097C396.338 218.935 396.502 221.54 396.874 224.808C397.407 227.228 397.735 229.444 397.878 231.928C398.041 245.769 394.968 260.747 384.912 271.072L383.52 272.38C375.224 280.767 365.966 286.101 354.43 288.53C339.87 291.115 325.668 287.719 313.405 279.654C301.243 271.177 294.093 258.156 291.455 243.743C289.519 229.172 293.227 215.185 301.939 203.37C312.118 191.053 324.9 184.027 340.8 182.297C357.043 181.548 370.283 187.543 382.425 197.997L384.625 199.973C384.71 200.026 384.794 200.081 384.878 200.136C387.397 201.742 388.818 201.858 391.866 201.44C394.578 199.435 395.824 198.168 396.613 194.867C396.191 192.949 395.634 191.668 394.763 190.432C394.098 189.612 393.414 188.805 392.71 188.018C378.613 174.578 361.351 168.056 341.98 168.056C324.195 168.999 307.664 176.187 295.409 189.169L293.385 191.425C289.519 195.653 286.663 200.227 284.048 205.3C275.309 223.049 274.842 241.855 281.029 260.461Z",
    fill: "#003F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.625 199.973L382.425 197.997C370.283 187.543 357.043 181.548 340.8 182.297C324.9 184.027 312.118 191.053 301.939 203.37C293.227 215.185 289.519 229.172 291.455 243.743C294.093 258.156 301.243 271.177 313.405 279.654C325.668 287.719 339.87 291.115 354.43 288.53C365.966 286.101 375.224 280.767 383.52 272.38L384.912 271.072C394.968 260.747 398.041 245.769 397.878 231.928C397.735 229.444 397.407 227.228 396.874 224.808C395.994 218.614 392.371 205.11 384.878 200.136C384.795 200.083 384.711 200.029 384.625 199.973Z",
    fill: "#003F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.462 212.498C375.174 213.124 375.174 213.124 377.208 214.898C378.811 217.846 379.225 219.002 378.513 222.305C376.861 224.796 374.746 226.84 372.67 228.981C371.76 229.962 370.851 230.944 369.945 231.928C365.097 237.183 360.188 242.347 355.095 247.365C353.51 248.975 352.026 250.636 350.554 252.35C341.572 262.683 341.572 262.683 337.044 264.295C330.779 263.704 327.216 258.74 323.032 254.456C321.207 252.631 319.347 250.939 317.379 249.272C310.95 243.681 310.95 243.681 309.242 240.665C309.191 237.613 309.435 235.836 311.068 233.259C313.283 231.883 314.987 231.589 317.588 231.485C321.093 232.923 323.416 235.565 326.018 238.23C327.675 239.904 329.361 241.526 331.098 243.117C331.89 243.851 331.89 243.851 332.698 244.6C334.421 245.985 334.421 245.985 337.618 245.673C339.302 244.098 340.765 242.562 342.26 240.822C343.15 239.821 344.041 238.821 344.933 237.823C345.383 237.318 345.832 236.814 346.295 236.294C348.285 234.107 350.376 232.045 352.484 229.972C355.065 227.424 357.544 224.862 359.891 222.096C367.307 213.529 367.307 213.529 372.462 212.498Z",
    fill: "#009A2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_227",
    x: 264.865,
    y: 166.056,
    width: 149.264,
    height: 148.539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_227",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.def7cae4dd801ed496b1c817a9266718.svg";
export { ForwardRef as ReactComponent };